module.exports = __webpack_public_path__ + "static/img/GYWM-21.2dc79a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutUs/GYWM-21.jpg
// module id = lXPn
// module chunks = 1